module.exports = __webpack_public_path__ + "static/media/shop_fill.4f4d906a.svg";